import Model from './model.js';

export default class MtdLimit extends Model {
    urlRoot() { return '/MtdLimits'; }

    initialize() {
        this.idAttribute = 'objectId';
        return super.initialize(...arguments);
    }
}



// WEBPACK FOOTER //
// ./app/new-models/mtd-limit.js